import React from 'react';
import { bool, number } from 'prop-types';
import { connect } from 'react-redux';
import { uid } from '@fiverr-private/futile';
import { isSinglePackage } from '../../../../../reducers/packages';
import { GIG_ITEM_ID, GIG_ITEM_PREFIX, QUANTITY } from './constants';

const FormGigItem = ({ packageId, id, quantity = 0, isSinglePackage = false }) => {

    const getFormGigItemInputNames = () => {
        const gigItemUid = uid();

        return {
            gigItemIdName: formatInputName(GIG_ITEM_ID, gigItemUid),
            quantityName: formatInputName(QUANTITY, gigItemUid)
        };
    };

    const formatInputName = (type, gigItemUid) => {
        if (isSinglePackage) {
            return `${GIG_ITEM_PREFIX}[${gigItemUid}][${type}]`;
        } else {
            return `${GIG_ITEM_PREFIX}[${packageId}][${gigItemUid}][${type}]`;
        }
    };

    const { gigItemIdName, quantityName } = getFormGigItemInputNames();

    return (
        <>
            <input type="hidden" name={gigItemIdName} value={id}/>
            <input type="hidden" name={quantityName} value={quantity}/>
        </>
    );
};

FormGigItem.propTypes = {
    packageId: number,
    id: number,
    quantity: number,
    isSinglePackage: bool
};

const mapStateToProps = ({ packages }) => ({
    isSinglePackage: isSinglePackage(packages)
});

export { FormGigItem };
export default connect(mapStateToProps)(FormGigItem);
